<form [formGroup]="applyform">
  <div class="apply-page">
    <ng-container *ngIf="isApplying; else pageContent">
      <div class="apply-card">
        <div class="app-spinner">
          <mat-spinner diameter="30"></mat-spinner>
        </div>
      </div>
    </ng-container>
    <ng-template #pageContent>
      <div class="apply-card" *ngIf="jobSubmitted as job">
        <div class="job-info">
          <button type="button" class="back-nav-btn" (click)="goToJobDetailPage()" title="Go Back">
            <i class="bi bi-arrow-left"></i>
          </button>

          <div class="job-logo">
            <img *ngIf="job.company_logo" [src]="job.company_logo" [alt]="job.company_name" class="company-logo-img">
            <i *ngIf="!job.company_logo" class="bi bi-robot"></i>
          </div>

          <div>
            <div class="job-company">{{ job.company_name }}</div>
            <div class="job-role">{{ job.job_title }}</div>
            <div class="job-location">
              {{ job.work_mode }} · {{ job.job_type }}
              <span class="ms-2" *ngFor="let location of job.locations">
                <i class="bi bi-geo-alt"></i>
                {{ location }}</span>
            </div>
          </div>
        </div>
      </div>
    </ng-template>

    <div class="apply-card">
      <div class="section-title">I am a</div>

      <div class="experience-options">
        <div class="experience-card" [class.active]="selectedType === 'fresher'" (click)="selectType('fresher')">
          <h4>Fresher</h4>
          <p>Recently graduated or final-year student</p>
        </div>

        <div class="experience-card" [class.active]="selectedType === 'experienced'"
          (click)="selectType('experienced')">
          <h4>Working Professional</h4>
          <p>I have work experience</p>
        </div>
      </div>
    </div>

    <div class="apply-card">
      <div class="form-title mb-2">Your details</div>

      <div class="profile-auto-fill-alert d-flex align-items-center justify-content-between py-2 mb-4 px-3"
        role="alert">
        <div class="d-flex align-items-center pe-3">
          <i class="bi bi-info-circle-fill me-3 fs-5"></i>
          <div>
            The details below are auto-filled from your Profile. To make any changes, please update your Profile.
            Changes will automatically reflect here.
          </div>
        </div>
        <button type="button" class="btn btn-sm text-nowrap profile-update-btn flex-shrink-0"
          (click)="onUpdateProfile()">
          Update Profile
        </button>
      </div>

      <div class="form-grid">
        <div class="form-group">
          <label>Full name *</label>
          <input type="text" formControlName="applicant_name" placeholder="Your full name" maxlength="50" readonly />
          <small class="text-danger smaller-text" *ngIf="
              applyform.get('applicant_name')?.touched &&
              applyform.get('applicant_name')?.hasError('required')
            ">
            Name is required
          </small>
          <small class="text-danger smaller-text" *ngIf="
              applyform.get('applicant_name')?.touched &&
              applyform.get('applicant_name')?.hasError('minLengthName')
            ">
            Name must be at least 2 characters long.
          </small>

          <small class="text-danger smaller-text" *ngIf="
              applyform.get('applicant_name')?.touched &&
              applyform.get('applicant_name')?.hasError('invalidName')
            ">
            Please enter a valid name. Name can contain only letters, spaces,
            apostrophes, periods and hyphens.
          </small>
          <small class="text-danger smaller-text" *ngIf="applyform.get('applicant_name')?.value?.length >= 50">
            Maximum 50 characters allowed</small>
        </div>

        <div class="form-group">
          <label>Mobile number *</label>
          <input type="text" formControlName="applicant_mobile" placeholder="10-digit mobile" minlength="10"
            maxlength="10" readonly />

          <small class="text-danger smaller-text" *ngIf="
              applyform.get('applicant_mobile')?.touched &&
              applyform.get('applicant_mobile')?.hasError('required')
            ">
            Mobile number is required.
          </small>

          <small class="text-danger smaller-text" *ngIf="
              applyform.get('applicant_mobile')?.touched &&
              !applyform.get('applicant_mobile')?.hasError('required') &&
              (applyform.get('applicant_mobile')?.hasError('pattern') ||
                applyform.get('applicant_mobile')?.hasError('minlength'))
            ">
            Enter a valid 10-digit mobile number.
          </small>
        </div>

        <div class="form-group">
          <label>Email *</label>
          <input type="email" formControlName="applicant_email" placeholder="you@example.com" readonly />
          <small class="text-danger smaller-text" *ngIf="
              applyform.get('applicant_email')?.touched &&
              applyform.get('applicant_email')?.hasError('required')
            ">
            Email is required.
          </small>

          <small class="text-danger smaller-text" *ngIf="
              applyform.get('applicant_email')?.touched &&
              applyform.get('applicant_email')?.hasError('emailSpace')
            ">
            Email address cannot contain spaces.
          </small>

          <small class="text-danger smaller-text" *ngIf="
              applyform.get('applicant_email')?.touched &&
              applyform.get('applicant_email')?.hasError('invalidEmail')
            ">
            Please enter a valid email address.
          </small>

          <small class="text-danger smaller-text" *ngIf="
              applyform.get('applicant_email')?.touched &&
              applyform.get('applicant_email')?.hasError('maxlength')
            ">
            Email cannot exceed 100 characters.
          </small>
        </div>

        <div class="form-group">
          <label>Current location *</label>
          <input type="text" formControlName="applicant_location" placeholder="e.g. Bangalore" maxlength="60"
            readonly />
          <small class="text-danger smaller-text" *ngIf="
              applyform.get('applicant_location')?.touched &&
              applyform.get('applicant_location')?.hasError('required')
            ">
            Location is required
          </small>
          <!-- <small class="text-danger smaller-text" *ngIf="applyform.get('applicant_location')?.value?.length >= 50">
            Maximum 50 characters allowed</small> -->
        </div>

        <div class="form-group">
          <label>Highest Education *</label>
          <input type="text" formControlName="education" placeholder="e.g. B.Tech / B.E" maxlength="60" readonly />
          <small class="text-danger smaller-text" *ngIf="
              applyform.get('education')?.touched &&
              applyform.get('education')?.hasError('required')
            ">
            Education is required.
          </small>

          <small class="text-danger smaller-text" *ngIf="
              applyform.get('education')?.touched &&
              applyform.get('education')?.hasError('minLengthEducation')
            ">
            Education must be at least 2 characters long.
          </small>

          <small class="text-danger smaller-text" *ngIf="
              applyform.get('education')?.touched &&
              applyform.get('education')?.hasError('maxLengthEducation')
            ">
            Education cannot exceed 60 characters.
          </small>

          <small class="text-danger smaller-text" *ngIf="
              applyform.get('education')?.touched &&
              applyform.get('education')?.hasError('invalidEducation')
            ">
            Please enter a valid education degree. Only letters, numbers, spaces, hyphens (-), periods (.), and forward
            slashes (/) are allowed.
          </small>
        </div>

        <div class="form-group">
          <label>College Name *</label>
          <input type="text" formControlName="college_name" placeholder="e.g. IIT Roorkee" readonly />
          <small class="text-danger smaller-text" *ngIf="
              applyform.get('college_name')?.touched &&
              applyform.get('college_name')?.hasError('required')
            ">
            College Name is required
          </small>
          <!-- <small class="text-danger smaller-text" *ngIf="applyform.get('college_name')?.value?.length >= 50">
            Maximum 50 characters allowed</small> -->
        </div>

        <div class="form-group">
          <label>Year of Passing *</label>

          <div class="select-wrapper">
            <select formControlName="year_of_passing_out" class="form-control" style="pointer-events: none;">
              <option value="" disabled selected>Select Year</option>
              <option *ngFor="let year of passingYears" [value]="year">
                {{ year }}
              </option>
            </select>
            <i class="bi bi-chevron-down"></i>
          </div>

          <small class="text-danger smaller-text" *ngIf="
              applyform.get('year_of_passing_out')?.touched &&
              applyform.get('year_of_passing_out')?.hasError('required')
            ">
            Passing out year is required
          </small>
        </div>

        <ng-container *ngIf="selectedType === 'experienced'">
          <div class="form-group">
            <label>Current / last job title *</label>
            <input type="text" formControlName="last_job_title" placeholder="Frontend Developer" maxlength="100"
              readonly />
            <small class="text-danger smaller-text" *ngIf="
                applyform.get('last_job_title')?.touched &&
                applyform.get('last_job_title')?.hasError('required')
              ">
              Job title is required.
            </small>

            <small class="text-danger smaller-text" *ngIf="
                applyform.get('last_job_title')?.touched &&
                applyform.get('last_job_title')?.hasError('minLengthJobTitle')
              ">
              Job title must be at least 2 characters long.
            </small>

            <small class="text-danger smaller-text" *ngIf="
                applyform.get('last_job_title')?.touched &&
                applyform.get('last_job_title')?.hasError('maxLengthJobTitle')
              ">
              Job title cannot exceed 100 characters.
            </small>

            <small class="text-danger smaller-text" *ngIf="
                applyform.get('last_job_title')?.touched &&
                applyform.get('last_job_title')?.hasError('invalidJobTitle')
              ">
              Please enter a valid job title. Only letters, numbers, spaces,
              hyphens (-), periods (.), forward slashes (/), and ampersands (&)
              are allowed.
            </small>
          </div>

          <div class="form-group">
            <label>Current / last company *</label>
            <input type="text" formControlName="last_company_name" placeholder="Google" maxlength="60" readonly />
            <small class="text-danger smaller-text" *ngIf="
                applyform.get('last_company_name')?.touched &&
                applyform.get('last_company_name')?.hasError('required')
              ">
              Company name is required.
            </small>

            <small class="text-danger smaller-text" *ngIf="
                applyform.get('last_company_name')?.touched &&
                applyform
                  .get('last_company_name')
                  ?.hasError('minLengthJobTitle')
              ">
              Company name must be at least 2 characters long.
            </small>

            <small class="text-danger smaller-text" *ngIf="
                applyform.get('last_company_name')?.touched &&
                applyform
                  .get('last_company_name')
                  ?.hasError('maxLengthJobTitle')
              ">
              Company name cannot exceed 100 characters.
            </small>

            <small class="text-danger smaller-text" *ngIf="
                applyform.get('last_company_name')?.touched &&
                applyform.get('last_company_name')?.hasError('invalidJobTitle')
              ">
              Please enter a valid company name. Only letters, numbers, spaces,
              hyphens (-), periods (.), forward slashes (/), and ampersands (&)
              are allowed.
            </small>
          </div>

          <div class="form-group">
            <label>Core expertise *</label>
            <input type="text" formControlName="core_experties" placeholder="Angular, Node.js" maxlength="60"
              readonly />
            <small class="text-danger smaller-text" *ngIf="
                applyform.get('core_experties')?.touched &&
                applyform.get('core_experties')?.hasError('required')
              ">
              Core expertise is required.
            </small>

            <small class="text-danger smaller-text" *ngIf="
                applyform.get('core_experties')?.touched &&
                applyform
                  .get('core_experties')
                  ?.hasError('minLengthCoreExpertise')
              ">
              Minimum length: 2 characters.
            </small>

            <small class="text-danger smaller-text" *ngIf="
                applyform.get('core_experties')?.touched &&
                applyform
                  .get('core_experties')
                  ?.hasError('maxLengthCoreExpertise')
              ">
              Maximum length: 200 characters.
            </small>

            <small class="text-danger smaller-text" *ngIf="
                applyform.get('core_experties')?.touched &&
                applyform
                  .get('core_experties')
                  ?.hasError('invalidCoreExpertise')
              ">
              Only letters, numbers, spaces, commas (,), hyphens (-), periods
              (.), ampersands (&), plus (+), and hash (#) are allowed.
            </small>
          </div>

          <div class="form-group">
            <label>Total years of experience *</label>
            <input type="text" formControlName="total_year_of_experience" placeholder="3" minlength="1" maxlength="20"
              readonly />
            <small class="text-danger smaller-text" *ngIf="
                applyform.get('total_year_of_experience')?.touched &&
                applyform.get('total_year_of_experience')?.hasError('required')
              ">
              Total years of experience is required.
            </small>

            <small class="text-danger smaller-text" *ngIf="
                applyform.get('total_year_of_experience')?.touched &&
                applyform.get('total_year_of_experience')?.hasError('pattern')
              ">
              Enter a valid experience value.
            </small>
          </div>

          <div class="form-group">
            <label>Current CTC *</label>
            <input type="text" formControlName="current_ctc" placeholder="8.50 LPA" minlength="1" readonly />
            <small class="text-danger smaller-text" *ngIf="
                applyform.get('current_ctc')?.touched &&
                applyform.get('current_ctc')?.hasError('invalidCtc')
              ">
              Enter a valid numeric value with up to 2 decimal places.
            </small>

            <small class="text-danger smaller-text" *ngIf="
                applyform.get('current_ctc')?.touched &&
                applyform.get('current_ctc')?.hasError('ctcOutOfRange')
              ">
              Value must be between 0 and 1000 Lakhs.
            </small>
          </div>

          <div class="form-group">
            <label>Expected CTC *</label>
            <input type="text" formControlName="expected_ctc" placeholder="12 LPA" minlength="1" readonly />
            <small class="text-danger smaller-text" *ngIf="
                applyform.get('expected_ctc')?.touched &&
                applyform.get('expected_ctc')?.hasError('invalidCtc')
              ">
              Enter a valid numeric value with up to 2 decimal places.
            </small>

            <small class="text-danger smaller-text" *ngIf="
                applyform.get('expected_ctc')?.touched &&
                applyform.get('expected_ctc')?.hasError('ctcOutOfRange')
              ">
              Value must be between 0 and 1000 Lakhs.
            </small>

            <small class="text-danger smaller-text" *ngIf="
                applyform.get('expected_ctc')?.touched &&
                applyform
                  .get('expected_ctc')
                  ?.hasError('expectedLessThanCurrent')
              ">
              Expected CTC should be greater than or equal to Current CTC.
            </small>
          </div>

          <div class="form-row">
            <div class="form-group">
              <label>City - 1st preference</label>
              <input type="text" formControlName="city_pref_1" placeholder="Bangalore" maxlength="60" readonly />
              <small class="text-danger smaller-text" *ngIf="
                  applyform.get('city_pref_1')?.touched &&
                  applyform.get('city_pref_1')?.hasError('minLengthCity')
                ">
                Minimum length is 2 characters.
              </small>

              <small class="text-danger smaller-text" *ngIf="
                  applyform.get('city_pref_1')?.touched &&
                  applyform.get('city_pref_1')?.hasError('maxLengthCity')
                ">
                Maximum length is 100 characters.
              </small>

              <small class="text-danger smaller-text" *ngIf="
                  applyform.get('city_pref_1')?.touched &&
                  applyform.get('city_pref_1')?.hasError('invalidCity')
                ">
                Only letters, spaces, hyphens (-) and periods (.) are allowed.
              </small>
            </div>

            <div class="form-group">
              <label>City - 2nd preference</label>
              <input type="text" formControlName="city_pref_2" placeholder="Pune" maxlength="60" readonly />
              <small class="text-danger smaller-text" *ngIf="
                  applyform.get('city_pref_2')?.touched &&
                  applyform.get('city_pref_2')?.hasError('minLengthCity')
                ">
                Minimum length is 2 characters.
              </small>

              <small class="text-danger smaller-text" *ngIf="
                  applyform.get('city_pref_2')?.touched &&
                  applyform.get('city_pref_2')?.hasError('maxLengthCity')
                ">
                Maximum length is 100 characters.
              </small>

              <small class="text-danger smaller-text" *ngIf="
                  applyform.get('city_pref_2')?.touched &&
                  applyform.get('city_pref_2')?.hasError('invalidCity')
                ">
                Only letters, spaces, hyphens (-) and periods (.) are allowed.
              </small>
            </div>

            <div class="form-group">
              <label>City - 3rd preference</label>
              <input type="text" formControlName="city_pref_3" placeholder="Hyderabad" maxlength="60" readonly />
              <small class="text-danger smaller-text" *ngIf="
                  applyform.get('city_pref_3')?.touched &&
                  applyform.get('city_pref_3')?.hasError('minLengthCity')
                ">
                Minimum length is 2 characters.
              </small>

              <small class="text-danger smaller-text" *ngIf="
                  applyform.get('city_pref_3')?.touched &&
                  applyform.get('city_pref_3')?.hasError('maxLengthCity')
                ">
                Maximum length is 100 characters.
              </small>

              <small class="text-danger smaller-text" *ngIf="
                  applyform.get('city_pref_3')?.touched &&
                  applyform.get('city_pref_3')?.hasError('invalidCity')
                ">
                Only letters, spaces, hyphens (-) and periods (.) are allowed.
              </small>
            </div>
          </div>

        </ng-container>
      </div>
    </div>

    <div class="apply-card">
      <div class="resume-header">
        <div class="resume-text">
          <h3>Upload resume*</h3>
          <p>PDF or DOC/DOCX — up to 5MB</p>
        </div>

        <span class="upload-resume" (click)="goToResumeBuilderPage()">
          Don't have a resume? Build One
        </span>
      </div>

      <ng-container *ngIf="!uploadedResume && !existingResumeUrl; else uploadedFileTemplate">
        <div class="resume-upload-box" (click)="fileInput.click()">
          <div class="resume-upload-icon">
            <i class="bi bi-cloud-arrow-up"></i>
          </div>

          <h4>Click to upload resume</h4>
          <p>PDF, DOC or DOCX (Max 10MB)</p>

          <input #fileInput type="file" hidden (change)="onResumeUpload($event)" />
        </div>
      </ng-container>

      <div class="saved-resumes-container" *ngIf="savedResumes.length > 0">
        <div class="saved-resumes-title">
          <i class="bi bi-folder-check"></i>
          <span>Or select one of your saved resumes:</span>
        </div>
        <div class="saved-resumes-list">
          <div class="saved-resume-item" *ngFor="let resume of savedResumes" (click)="selectSavedResume(resume.resume_id)">
            <div class="resume-icon">
              <i class="bi bi-file-earmark-text"></i>
            </div>
            <div class="resume-info">
              <span class="resume-name">{{ resume.resume_name || 'Untitled Resume' }}</span>
              <span class="resume-date">Updated on {{ resume.updated_at | date:'mediumDate' }}</span>
            </div>
            <div class="select-action">
              <span>Select & View <i class="bi bi-chevron-right"></i></span>
            </div>
          </div>
        </div>
      </div>

      <ng-template #uploadedFileTemplate>
        <div class="uploaded-file-card">
          <div class="file-left">
            <div class="pdf-icon">
              <i class="bi bi-file-earmark-pdf-fill"></i>
            </div>

            <div class="file-details">
              <h5 *ngIf="uploadedResume">{{ uploadedResume.name }}</h5>
              <h5 *ngIf="!uploadedResume && existingResumeUrl">
                <a [href]="existingResumeUrl" target="_blank" rel="noopener noreferrer"
                  (click)="$event.stopPropagation()">View Existing Resume</a>
              </h5>
              <p *ngIf="uploadedResume">{{ uploadedResumeSize }}</p>
            </div>
          </div>
          <div class="file-actions">
            <button type="button" class="replace-file-btn" (click)="replaceInput.click()">
              <i class="bi bi-arrow-repeat"></i>
              Replace
            </button>
            <input #replaceInput type="file" hidden (change)="onResumeUpload($event)" />
            <button type="button" class="remove-file-btn" (click)="removeResume()">
              <i class="bi bi-x-lg"></i>
            </button>
          </div>
        </div>
      </ng-template>
    </div>

    <label class="consent" *ngIf="jobSubmitted as job">
      <input type="radio" [value]="true" formControlName="consent" />

      <span>
        I confirm the information provided is accurate, I agree to
        <strong>BeExpert's Terms of Service</strong> and
        <strong>Privacy Policy</strong>, and I consent to my data being shared
        with <strong>{{ job.company_name }}</strong> for this application.
      </span>
    </label>
    <small class="text-danger smaller-text" *ngIf="
        applyform.get('consent')?.touched &&
        applyform.get('consent')?.hasError('required')
      ">
      Please accept the consent before submitting.
    </small>

<div class="mobile-action-bar">
  <div class="action-buttons">
      <button type="button" class="btn-cancel" (click)="goToJobDetailPage()">Back</button>

      <button type="button" class="upload-btn" (click)="submitForm()" [disabled]="isLoading || applyform.invalid">
        <ng-container *ngIf="isLoading; else noLoading">
        <span class="spinner-border spinner-border-sm" role="status"></span>
          <span> Saving...</span>
        </ng-container>
        <ng-template #noLoading>
          <span> Submit application </span>
        </ng-template>
      </button>
   </div>
    </div>
  </div>
</form>